import { emptySplitApiV2 } from './emptyApiV2'
import type {
	CustomAttributeComboDto,
	CustomAttributeDto,
	CustomAttributeStructureTypeEnum,
} from './mddApiSliceGenerated'
import { GetFullTreeStructureV2ApiArg, StructureMetadataDtoRead } from './mddApiSliceGeneratedV2'

export type GetFullTreeV2Arg = GetFullTreeStructureV2ApiArg & { branchId?: number }

export const mddApiV2Enhanced = emptySplitApiV2.injectEndpoints({
	endpoints: (build) => ({
		getFullTreeV2: build.query<StructureMetadataDtoRead[], GetFullTreeV2Arg | undefined>({
			query: (filter) => {
				const params = new URLSearchParams()
				
				if (filter?.type) {
					filter.type.forEach((t) => params.append('type', t))
				}
				
				if (filter?.locked !== undefined) {
					params.append('locked', String(filter.locked))
				}

				if (filter?.maxLevel !== undefined) {
					params.append('maxLevel', String(filter.maxLevel))
				}
				
				const queryString = params.toString()
				const path =
					filter?.branchId != null
						? `/v2/branch/${filter.branchId}/structure/tree`
						: `/v2/structure/tree`
				return {
					url: `${path}${queryString ? `?${queryString}` : ''}`,
				}
			},
			providesTags: ['Structure'],
		}),
		getCustomAttributesComboV2: build.query<
			CustomAttributeComboDto[],
			{ structureType: CustomAttributeStructureTypeEnum }
		>({
			query: ({ structureType }) => ({
				url: `/v2/custom-attributes/combo/${structureType}`,
			}),
		}),
		getAllCustomAttributesV2: build.query<CustomAttributeDto[], void>({
			query: () => ({ url: `/v2/custom-attributes` }),
		}),
	}),
	overrideExisting: false,
})

export const {
	useGetFullTreeV2Query,
	useLazyGetFullTreeV2Query,
	useGetCustomAttributesComboV2Query,
	useGetAllCustomAttributesV2Query,
} = mddApiV2Enhanced

